export default __webpack_public_path__ + "static/media/Image3_Mobile.0ee8786a.png";